import { cn } from "tailwind-variants";
import type {
	IconUmbBlockElementModel,
	IconUmbBlockSettingsElementModel,
} from "#/_generated/umbraco/delivery-api/models";
import {
	Icon,
	type IconIntentColor,
	type IconSizeScale,
} from "#/_packages/umbrella/features/icons/components/icon";
import type { BlockItemProps } from "#/_packages/umbrella/integrations/umbraco/types";
import { toHoverItemCssClasses } from "#/_packages/umbrella/integrations/umbraco/utils/animation-utils.ts";
import { getUmbLink } from "#/_packages/umbrella/integrations/umbraco/utils/link-utils.ts";

type IconBlockProps = BlockItemProps & {
	content: IconUmbBlockElementModel;
	settings: IconUmbBlockSettingsElementModel;
};

function toAlignmentSelfVerticalClass(value?: string | null) {
	switch (value) {
		case "start":
			return "self-start";
		case "center":
			return "self-center";
		case "end":
			return "self-end";
		default:
			return "";
	}
}

export default function IconUmbBlock({
	className,
	content,
	settings,
}: IconBlockProps) {
	if (!content.properties?.icon) return null;

	const icon = content.properties.icon
		.replaceAll("/umbrella/ui/icons/", "")
		.replaceAll(".svg", "");

	const link = getUmbLink(content.properties?.link?.[0], {
		requireHref: true,
	});
	const blockClasses = cn(
		toHoverItemCssClasses(settings.properties?.animationHoverType),
		toAlignmentSelfVerticalClass(settings.properties?.alignmentSelfVertical),
		className,
	);

	return (
		<Icon
			icon={icon}
			size={(content.properties?.size as IconSizeScale) ?? undefined}
			intentColor={
				(content.properties?.intentColor as IconIntentColor) ?? undefined
			}
			caption={content.properties?.caption ?? undefined}
			href={link?.href}
			target={link?.target}
			trackingEvent={link?.trackingEvent}
			noFollow={link?.noFollow}
			className={blockClasses}
		/>
	);
}
